import React, { useContext, useEffect, useState, useRef } from "react";
// import Header4 from "../components/Header4";
import { Dropdown, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Header3 from "../components/Header3";
import { FaVideo } from "react-icons/fa";
import SocketContext from "../context/SocketContext";
import { BASE_URL, Frontend } from "../config/BaseUrls";
import axios from "../AxiosInstance";
import { ensureHttps, resolveBookImageUrl } from "../utils/urlHelpers";
import { ChatState } from "../context/ChatProvider";
import { useAuth } from "../context/auth";
import { useSearchParams } from "react-router-dom";

import { LanguageContext } from "../context/LanguageContext";
import {
  CalendarDays,
  MapPin,
  User,
  Globe,
  Crown,
  Share2,
  Check,
  ChevronDown,
  Search,
  ExternalLink,
  Star,
  Facebook,
  Twitter,
  Linkedin,
  Mail,
  LanguagesIcon,
  ChevronRight,
  Link as LinkIcon,
  Video,
  Instagram,
  Music,
  MessageCircle,
  Send,
  Camera,
  Mars,
  Venus,
  User2,
} from "lucide-react";
// ---------- Layout primitives ----------
const Container = ({ children }) => (
  <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
    {children}
  </div>
);

const Card = ({ children, className = "" }) => (
  <div className={`rounded-3xl p-5 shadow-sm ${className}`}>{children}</div>
);

const Pill = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold ${className}`}
  >
    {children}
  </span>
);

const Button = ({
  variant = "primary",
  className = "",
  children,
  disabled = false,
  ...props
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-2xl px-[20px] py-[8px] text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  const styles = {
    primary: "bg-[#34c3c9] text-white hover:brightness-95 focus:ring-[#34c3c9]",
    secondary:
      "bg-white text-[#34c3c9] ring-1 ring-[#34c3c9] hover:bg-[#f2f2f2] focus:ring-[#34c3c9]",
    ghost: "text-[#34c3c9] hover:bg-[#f2f2f2] focus:ring-[#34c3c9]",
  };
  return (
    <button
      className={`${base} ${styles[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

// ---- Non-binary badge ----
const NonBinaryBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center justify-center rounded-full bg-black text-white border-2 border-black ${className}`}
    aria-label="non-binary"
    title="Non-binary"
  >
    <span className="text-[10px] leading-none font-extrabold">NB</span>
  </span>
);

const MeetupOrganizer = () => {
  const { lg } = useContext(LanguageContext);
  const TitleStyles = () => (
    <style>{`
      .book-title { font-size: clamp(1.25rem, 2vw + 0.5rem, 2rem); line-height: 1.2; word-break: break-word; hyphens: auto; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; }
      @media (max-width: 639px) { .book-title { -webkit-line-clamp: 2; } }
      @media (min-width: 640px) { .book-title { -webkit-line-clamp: 2; } }
      @media (min-width: 1024px) { .book-title { -webkit-line-clamp: 3; } }
    `}</style>
  );
  const socket = useContext(SocketContext);
  const [searchParams] = useSearchParams();

  const { user, setShowLoginM } = ChatState();
  const userData = user || JSON.parse(localStorage.getItem("userInfo"));
  const [selectedOption, setSelectedOption] = useState("OPEN");

  // useEffect(() => {
  //   localStorage.setItem("chatStatus", selectedOption);
  // }, [selectedOption]);

  console.log(userData, "userDatauserData");

  const handleSelect = (option) => {
    setSelectedOption(option);
  };
  const getClasses = () => {
    switch (selectedOption) {
      case "OPEN":
        return "bg-[#bbf7d0] text-[#166534]"; // green
      case "CONSULTATION":
        return "bg-[#fef9c3] text-[#a16207]"; // yellow
      default: // BOOKED
        return "bg-[#fecaca] text-[#991b1b]"; // red
    }
  };

  const navigate = useNavigate();

  const [sShow, setSShow] = useState(false); // For signup modal
  const [sLShow, setSLShow] = useState(false); // For signup modal
  const [wShow, setWShow] = useState(false); // For signup modal
  const [isJoined, setIsJoined] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [countries, setCountries] = useState([]);
  const [buyCatalog, setBuyCatalog] = useState({}); // { "United Kingdom": [...], ... }
  const [buyMenuOpen, setBuyMenuOpen] = useState(false);
  const [activeCountry, setActiveCountry] = useState(null);
  const [buyQuery, setBuyQuery] = useState("");
  const buyMenuRef = useRef(null);
  const [showJoined, setShowJoined] = useState(false);
  const hasManuallySelectedCountry = useRef(false);
  const allCountries = Object.keys(buyCatalog);

  // ✅ Detect user's country automatically (only once, and only if user hasn't manually selected)
  useEffect(() => {
    // Don't auto-detect if user has manually selected a country
    if (hasManuallySelectedCountry.current) {
      return;
    }

    // Only auto-detect if buyCatalog is loaded and activeCountry is not set
    if (Object.keys(buyCatalog).length === 0 || activeCountry !== null) {
      return;
    }

    const detectCountry = async () => {
      try {
        const res = await fetch("https://ipwho.is/");
        const data = await res.json();
        console.log(data, "ip dres");

        if (data && data.country) {
          const country = data.country;
          // Only auto-select if it's part of the buyCatalog and user hasn't manually selected
          if (
            Object.keys(buyCatalog).includes(country) &&
            !hasManuallySelectedCountry.current
          ) {
            setActiveCountry(country);
          }
        }
      } catch (err) {
        console.error("Failed to detect country:", err);
      }
    };

    detectCountry();
  }, [buyCatalog, activeCountry]);
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const { data } = await axios.get("api/v1/stores/");

        // Transform into { country: [stores] } shape
        const catalog = {};
        data.forEach((entry) => {
          catalog[entry.country.trim()] = entry.stores.map((store) => ({
            name: store.name,
            url: store.link,
          }));
        });

        console.log("Transformed buyCatalog:", catalog);
        setBuyCatalog(catalog);

        const countryList = data.map((entry) => entry.country.trim());
        console.log("Countries list:", countryList);
        setCountries(countryList);
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, []);
  const handleCloseS = () => {
    setSShow(false); // Close  modal
  };
  const filteredCountries = countries.filter((country) =>
    country.toLowerCase().includes(buyQuery.toLowerCase())
  );
  // Stars with half support
  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => {
      const full = i + 1 <= Math.floor(rating);
      const half = !full && i < rating;
      return (
        <div
          key={i}
          className="relative h-[17px] w-[17px]"
          data-testid={`star-${i}`}
        >
          <Star className="absolute inset-0 h-[17px] w-[17px] text-gray-300" />
          {full && (
            <Star className="absolute inset-0 h-[17px] w-[17px] text-yellow-400 fill-yellow-400" />
          )}
          {half && (
            <Star
              className="absolute inset-0 h-[17px] w-[17px] text-yellow-400"
              style={{ clipPath: "inset(0 50% 0 0)" }}
              fill="#fbbf24"
            />
          )}
        </div>
      );
    });
  const getGenderIcon = (gender) => {
    if (gender === "Male") return <Mars className="text-sky-700 w-6 h-6" />;
    if (gender === "Female") return <Venus className="text-pink-700 w-6 h-6" />;
  };

  // Status pill logic
  const statusPill =
    selectedOption === "booked" ? (
      <Pill className="bg-[#fecdd3] text-[#9f1239]">BOOKED</Pill>
    ) : (
      <Pill className="bg-[#bbf7d0] text-[#166534]">OPEN</Pill>
    );
  const handleCloseSL = () => {
    setSLShow(false);
    setSShow(false); // Close  modal
  };

  const handleCloseW = () => {
    setWShow(false);
  };

  const handleShowW = () => {
    setWShow(true); // Open  modal
    setIsJoined(true);
  };

  const handleShowS = () => {
    setSShow(true); // Open  modal
  };

  const handleShowSL = () => {
    setSLShow(true);
    setSShow(false); // Open  modal
  };
  // ?FET DATA DANMACALLY?
  const [eventData, setEventData] = useState(null);
  function calculateAge(dateOfBirth) {
    const dob = new Date(dateOfBirth);
    const today = new Date();

    const ageInMs = today - dob;
    const ageDate = new Date(ageInMs); // milliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  const eventId = searchParams.get("id") || searchParams.get("bookid");
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    const getEventData = async () => {
      if (eventId) {
        // If eventId exists, fetch from backend
        try {
          const res = await axios.get(`api/v1/books/${eventId}`, {
            headers: { "x-timezone": userTimeZone },
          });
          const raw = res.data;
          let sta;
          if (raw?.attendees?.includes(user?._id)) {
            setIsJoined(true);
            sta = "BOOKED";
          } else if (raw?.attendees?.length >= 1) {
            sta = "FULL";
          } else {
            sta = "OPEN";
          }

          setSelectedOption(sta);
          console.log("📦 Event data from backend:", raw, sta);
          setEventData(formatEventData(raw, eventId));
        } catch (error) {
          console.error("Error fetching event data", error);
          // If fetch fails, try localStorage as fallback
          // checkLocalStorage();
        }
      } else {
        // If no eventId, check localStorage
        // checkLocalStorage();
      }
    };
    const formatEventData = (raw, id) => {
      console.log(raw, "rawrawrawrawrawrawrawraw");

      return {
        type: raw.name,
        location: raw?.location?.name || "",
        city: raw.city || "",
        link: raw.link || "",
        title: raw.title || "",
        pages: raw.pageNumber || "",
        image: raw.image || "",
        author: raw.author || "",
        age: raw.age || "",
        language: raw.language || "",
        utcTime: raw.globalTime || "",
        gender: raw.gender || "Unspecified",
        detail: raw.description || "",
        eventType: raw.type || "",
        publisher: raw.publisher || "",
        createdAt: raw?.dateInfo,
        time: raw?.timeTrack,
        localTime: raw?.localTime || null, // ✅ Backend-converted time to viewer's timezone
        userId: raw.userId || {},
        meetingLink: raw.meetingLink || "",
        eventId: raw._id || id,
        attendees: raw.attendees || [],
        LangLat: raw?.location || null,
        EAN: raw.EAN,
        aboutBook: raw.aboutBook || "",
        rating: raw.rating,
        totalReviews: raw.totalReviews,
      };
    };

    getEventData();
  }, [eventId]);
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle chat request
  const requestChat = async () => {
    if (!userData?._id) {
      setShowLoginM(true);

      return;
    }

    if (!userData?._id || !eventData?.userId?._id) {
      toast.error("Missing required user or event information");
      return;
    }
    if (userData?._id == eventData?.userId?._id) {
      toast.error("Event creator could not join event as attendee.");
      return;
    }

    if (socket) {
      socket.emit("request_chat", {
        userId: userData?._id,
        ambassadorId: eventData?.userId?._id,
        eventData: eventData,
      });
      //  handleShowW(true);
      setSelectedOption("BOOKED"); // Set status to BOOKED
      try {
        // 1. Call API to update attendees
        const response = await axios.put(
          `/api/v1/books/update-attendees/${eventData?.eventId}`,
          {
            attendeeIds: [...eventData?.attendees, user?._id], // Assuming you have currentUserId
          }
        );

        // 2. Only update state if API call succeeds
        if (response.status === 200) {
          setShowJoined(true);

          localStorage.setItem(
            "eventDataNew",
            JSON.stringify({
              ...eventData,
              attendees: [...eventData?.attendees, user?._id],
            })
          );
        }
      } catch (error) {
        console.error("Error updating attendees:", error);
      }
      toast.success(lg?.yourRequestHasBeenSent || "Your request has been sent to the ambassador");
    } else {
      toast.error("You must be logged in to request a chat.");
    }
  };

  // Full text content
  const limit = 70;
  const fullText = eventData?.aboutBook || eventData?.title || "";

  const isLongText = fullText.length > limit;
  const shortText = fullText.slice(0, limit); // Adjust the length as needed

  const joinedStatus = localStorage.getItem("joinuserorgain");

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Social share

  //const shareUrl = `${Frontend}/meetorganizer?id=${eventId}`;
  const eventTitle =
    `Check out this event! ${eventData?.title}` || "Check out this event!";
  const eventImage = ensureHttps(`${BASE_URL}/uploads/${eventData?.image}`);

  const baseApiUrl = `${BASE_URL}/share`;
  const shareUrl = `${baseApiUrl}/${eventData?.eventId}`; // this is the new backend route
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(eventTitle || "Check out this event!");

  // FAtch User Details
  const [auth, setAuth] = useAuth();

  const userId = auth?.user?._id;

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);
  const getLanguageName = (code) => {
    try {
      return new Intl.DisplayNames(["en"], { type: "language" }).of(code);
    } catch {
      return code || "Unknown";
    }
  };

  // Format time to 24-hour format (HH:mm)
  function formatTime24(time24) {
    if (!time24) return "";

    // Handle both "HH:mm" string format and number format
    let hours, minutes;
    if (typeof time24 === "string" && time24.includes(":")) {
      [hours, minutes] = time24.split(":").map(Number);
    } else if (typeof time24 === "number") {
      hours = time24;
      minutes = 0;
    } else {
      return "";
    }

    // Ensure 24-hour format: HH:mm
    const hoursStr = hours.toString().padStart(2, "0");
    const minutesStr = minutes ? minutes.toString().padStart(2, "0") : "00";

    return `${hoursStr}:${minutesStr}`;
  }

  const [reviews, setReviews] = useState([]);

  const [loading, setLoading] = useState(true); // Track loading state
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);

  // Define fetchReviews outside of useEffect so you can call it from other functions
  const fetchReviews = async (bookIdFromURL, offilioFlag, searchBookFlag) => {
    console.log(bookIdFromURL, "bookIdFromURLbookIdFromURL");

    if (!bookIdFromURL) return; // Wait until userId and bookId are available

    setLoading(true); // Start loading
    try {
      const response = await axios.get(
        `api/v1/review/getreviews/${bookIdFromURL}?offilio=${offilioFlag}&searchbook=${searchBookFlag}`
      );
      // setReviews(response.data.reviews);
      const reviewsData = response.data.reviews || [];
      setReviews(reviewsData);
      console.log("📦 Reviews from backend:", reviewsData);
      // setCoverImage(response.data.bookCoverImage);

      setAverageRating(response.data.averageRating);
      setTotalReviews(response.data.totalReviews);

      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch reviews or user names");
      setLoading(false);
    }
  };
  const location = useLocation();

  const searchParamss = new URLSearchParams(location.search);
  const searchbook = searchParamss.get("searchbook");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const bookIdFromURL = searchParams.get("bookid");
    const offilioFlag = searchParams.get("offilio");
    const searchBookFlag = searchParamss.get("searchbook");

    fetchReviews(bookIdFromURL, offilioFlag, searchBookFlag);
  }, []);
  const handleBookCoverClick = () => {
    console.log(eventData, "eventData eventData eventData");

    const selectedBookObj = {
      bookId: eventId, // 👈 Use book.id if available
      bookCoverImage: eventData.image, // <== This is correct
      title: eventData.title,
      author: eventData.author,
      descriptions: eventData.aboutBook, // ✅ add this
      titless: eventData.title,
      publisher: eventData.publisher,
      book: eventData,
      EAN: eventData.EAN, // 👈 Add EAN if available
      isSearchBook: true, // 👈 Add this if coming from searchbook
    };

    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    navigate(`/reviews?bookid=${eventId}&searchbook=true`);
  };
  return (
    <>
      <div className="grouup">
        <Header3 />
      </div>

      <TitleStyles />
      <div className="min-h-screen bg-gradient-to-b from-white to-[#f2f2f2] pb-52 pt-8">
        <Container>
          {/* Top grid */}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
            {/* Cover + Details */}
            <Card className="md:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-6 bg-white ring-1 ring-[#f2f2f2] p-6">
              <div className="md:col-span-1 flex flex-col items-center">
                <div className="relative aspect-[2/3] w-full max-w-[300px] rounded-md overflow-hidden shadow-lg ring-1 ring-[#d1d1d1] hover:scale-[1.02] transition-transform">
                  {eventData?.image?.trim() && (
                    <img
                      onClick={handleBookCoverClick}
                      src={
                        resolveBookImageUrl(eventData.image)
                      }
                      alt="Book cover"
                      className="h-full w-full object-cover cursor-pointer"
                    />
                  )}
                  {selectedOption === "BOOKED" && (
                    <div className="absolute left-[-36px] top-6 w-[176px] rotate-[-45deg] bg-[#be123c] text-center text-[12px] font-extrabold text-white shadow-lg">
                      &nbsp;BOOKED&nbsp;
                    </div>
                  )}
                </div>
                {/* Reviews */}
                <div className="mt-3 flex items-center gap-2">
                  <div className="flex">
                    {renderStars(eventData?.rating || 0)}
                  </div>
                  <span className="text-sm text-slate-600">
                    ({eventData?.totalReviews ?? 0} reviews)
                  </span>
                </div>
              </div>
              {eventData && (
                <div className="md:col-span-2">
                  <div className="flex flex-wrap items-center gap-2">
                    <Pill className="bg-[#ffe4e6] text-[#be123c]">
                      BOOK DUO
                    </Pill>
                    <Pill className={getClasses()}>{selectedOption}</Pill>
                  </div>
                  <h1
                    className="mt-2 book-title font-semibold tracking-tight"
                    title={eventData?.title}
                    data-testid="book-title"
                  >
                    {eventData?.title}
                  </h1>
                  {/* <EventTitle title={eventData?.title} /> */}
                  <p className="text-sm text-[#a6a6a6] break-words">
                    {eventData?.author ? "by " + eventData?.author + "" : ""}
                    {eventData?.pages
                      ? ` - ${parseInt(eventData.pages, 10)} pages`
                      : ""}{" "}
                  </p>

                  <div className="mt-4 space-y-2 text-sm">
                    <div className="flex items-start gap-2 text-slate-700">
                      <CalendarDays className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium"> {lg?.when}:</span>{" "}
                        {eventData?.createdAt?.dayName &&
                        eventData?.createdAt?.day &&
                        eventData?.createdAt?.month &&
                        eventData?.createdAt?.year
                          ? (() => {
                              const shortToFullMonth = {
                                Jan: "January",
                                Feb: "February",
                                Mar: "March",
                                Apr: "April",
                                May: "May",
                                Jun: "June",
                                Jul: "July",
                                Aug: "August",
                                Sep: "September",
                                Oct: "October",
                                Nov: "November",
                                Dec: "December",
                              };
                              const fullMonth =
                                shortToFullMonth[eventData.createdAt.month] ||
                                eventData.createdAt.month;
                              // Translate day abbreviation
                              const dayMap = {
                                "Mon": lg?.dayMon || "Mon",
                                "Tue": lg?.dayTue || "Tue",
                                "Wed": lg?.dayWed || "Wed",
                                "Thu": lg?.dayThu || "Thu",
                                "Fri": lg?.dayFri || "Fri",
                                "Sat": lg?.daySat || "Sat",
                                "Sun": lg?.daySun || "Sun",
                              };
                              const translatedDay = dayMap[eventData.createdAt.dayName] || eventData.createdAt.dayName;
                              return `${translatedDay}, ${eventData.createdAt.day} ${fullMonth} ${eventData.createdAt.year}`;
                            })()
                          : "TBD"}
                        {eventData?.localTime && (
                          <span className="ml-2 font-medium text-[#34c3c9]">
                            at {formatTime24(eventData.localTime)}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      {eventData?.eventType === "On-line" ? (
                        <Video className="mt-0.5" size={18} />
                      ) : (
                        <MapPin className="mt-0.5" size={18} />
                      )}
                      <div>
                        <span className="font-medium"> {lg?.where}:</span>{" "}
                        {eventData?.eventType === "On-line" ? (
                          isJoined ? (
                            <a
                              href={eventData?.meetingLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-[#34c3c9] hover:underline"
                              style={{
                                cursor: "pointer",
                                opacity: "1",
                                fontSize: "16px",
                              }}
                            >
                              {eventData?.meetingLink}
                            </a>
                          ) : (
                            <>
                              On-line
                              <span style={{ fontSize: "13px", color: "gray" }}>
                                – Link visible to attendees only
                              </span>
                            </>
                          )
                        ) : (
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              `${
                                eventData?.location &&
                                `${eventData?.location?.address},`
                              } ${eventData?.city}`
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#34c3c9] hover:underline"
                          >
                            {eventData?.location &&
                              `${eventData?.location?.address},`}
                            {eventData?.city}
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      <Globe className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium"> {lg?.language}:</span>{" "}
                        {getLanguageName(eventData?.language)}
                      </div>
                    </div>
                  </div>

                  {/* Buy on (Nested dropdown) */}
                  <div className="mt-6" ref={buyMenuRef}>
                    <label className="mb-3 block text-sm font-semibold text-slate-700">
                      {lg?.buyon || "Buy on"}
                    </label>
                    <button
                      type="button"
                      onClick={() => setBuyMenuOpen((v) => !v)}
                      className="flex w-full max-w-md items-center justify-between rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 text-sm text-slate-800 hover:bg-[#fafafa] transition-colors focus:outline-none focus:ring-2 focus:ring-[#34c3c9] focus:ring-offset-2"
                      aria-expanded={buyMenuOpen}
                    >
                      <span className="font-medium">
                        {activeCountry ||
                          lg?.chooseYourCountry ||
                          "Choose your country"}
                      </span>
                      <ChevronDown
                        className={`h-4 w-4 transition-transform ${
                          buyMenuOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {buyMenuOpen && (
                      <div className="relative z-20 mt-2 w-full max-w-2xl overflow-hidden rounded-2xl border border-[#e5e5e5] bg-white shadow-xl">
                        {/* Search */}
                        <div className="border-b border-[#f0f0f0] p-3">
                          <div className="relative">
                            <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-[#a6a6a6]" />
                            <input
                              value={buyQuery}
                              onChange={(e) => setBuyQuery(e.target.value)}
                              placeholder="Search country..."
                              className="w-full rounded-lg border border-[#e5e5e5] bg-white py-2 pl-9 pr-3 text-sm focus:border-[#34c3c9] focus:outline-none"
                            />
                          </div>
                        </div>

                        {/* Two-pane nested menu */}
                        <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
                          {/* Countries */}
                          <div className="max-h-80 overflow-auto">
                            {filteredCountries.length === 0 ? (
                              <div className="px-4 py-8 text-center text-sm text-slate-500">
                                No countries
                              </div>
                            ) : (
                              filteredCountries.map((c) => (
                                <button
                                  key={c}
                                  onClick={() => {
                                    hasManuallySelectedCountry.current = true;
                                    setActiveCountry(c);
                                  }}
                                  className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm hover:bg-[#f9f9f9] transition-colors ${
                                    activeCountry === c
                                      ? "bg-[#f6fffe] text-[#0f766e] font-medium"
                                      : ""
                                  }`}
                                >
                                  <span>{c}</span>
                                  <ChevronDown className="h-4 w-4 -rotate-90" />
                                </button>
                              ))
                            )}
                          </div>

                          {/* Sellers */}
                          <div className="border-t border-[#f2f2f2] sm:border-l sm:border-t-0 max-h-80 overflow-auto">
                            {!activeCountry ? (
                              <div className="px-4 py-8 text-center text-sm text-slate-500">
                                <p className="mb-1">
                                  Select a country to see sellers
                                </p>
                                <p className="text-xs text-slate-400">
                                  Choose from the list on the left
                                </p>
                              </div>
                            ) : !buyCatalog[activeCountry] ||
                              buyCatalog[activeCountry].length === 0 ? (
                              <div className="px-4 py-8 text-center text-sm text-slate-500">
                                <p className="mb-1">No sellers available</p>
                                <p className="text-xs text-slate-400">
                                  for {activeCountry}
                                </p>
                              </div>
                            ) : (
                              <div>
                                <div className="sticky top-0 bg-white border-b border-[#f2f2f2] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
                                  {activeCountry} (
                                  {buyCatalog[activeCountry]?.length || 0}{" "}
                                  {buyCatalog[activeCountry]?.length === 1
                                    ? "seller"
                                    : "sellers"}
                                  )
                                </div>
                                <div className="divide-y divide-[#f2f2f2]">
                                  {buyCatalog[activeCountry]?.map(
                                    (s, index) => (
                                      <a
                                        key={s.name || index}
                                        href={s.url || s.link || "#"}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="flex items-center justify-between px-4 py-3 text-sm hover:bg-[#f6fffe] transition-colors group"
                                        onClick={() => setBuyMenuOpen(false)}
                                      >
                                        <span className="font-medium text-slate-700 group-hover:text-[#34c3c9] transition-colors">
                                          {s.name}
                                        </span>
                                        <ExternalLink className="h-4 w-4 text-[#a6a6a6] group-hover:text-[#34c3c9] transition-colors" />
                                      </a>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Card>
            {/* Organizer / Looking For */}
            <Card className="md:col-span-4 bg-[#f0f0f0]">
              <h3 className="mb-3 text-sm font-semibold tracking-wide text-slate-700">
                Organizer
              </h3>
              <div className="flex items-center gap-3">
                <img
                  src={
                    eventData?.userId?.profileImage
                      ? eventData?.userId?.profileImage.startsWith("http")
                        ? ensureHttps(eventData?.userId?.profileImage) // ✅ external URL - ensure HTTPS
                        : ensureHttps(
                            `${BASE_URL}/uploads/${eventData?.userId?.profileImage}`
                          ) // ✅ internal URL - ensure HTTPS
                      : require("../pages/image/addphotoicon.png")
                  }
                  className="h-12 w-12 cursor-pointer object-contain rounded-full"
                  alt="Organizer"
                  onClick={() => {
                    if (!user?._id) {
                      setShowLoginM(true);
                      // toast.error("You must be logged in");
                      return;
                    } else
                      navigate(
                        `/ambassadoruserprofile?id=${eventData?.userId?._id}`
                      );
                  }}
                />
                <div className="font-medium flex flex-col">
                  <span className="flex items-center gap-2">
                    {eventData?.userId?.name}{" "}
                    {getGenderIcon(eventData?.userId?.gender)}
                  </span>
                </div>
              </div>

              <div className="my-5 h-[3px] w-full bg-[#fff]" />

              <h3 className="mb-3 text-sm font-semibold tracking-wide text-slate-700">
                {lg?.lookigfr || "Looking for"}
              </h3>
              <div className="space-y-2 text-sm text-slate-700">
                <div className="flex items-center gap-1">
                  <User2 size={16} />{" "}
                  <span className="font-medium"> {lg?.gender}:</span>
                  <span className="ml-1 inline-flex items-center gap-1 align-middle">
                    {eventData?.gender} {getGenderIcon(eventData?.gender)}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <User size={16} /> {lg?.age}:{" "}
                  <span className="font-medium">{eventData?.age}</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin size={16} /> {lg?.locatedin}:{" "}
                  <span className="font-medium">
                    {eventData?.eventType === "On-line"
                      ? "On-line"
                      : eventData?.city || ""}
                  </span>
                </div>
              </div>
            </Card>
          </div>

          {/* About */}
          {eventData && (
            <div className="mt-10">
              <Card className="bg-white ring-1 ring-[#f2f2f2]">
                <h2 className="text-lg font-semibold"> {lg?.aboutbook}</h2>
                <div className="mt-3 space-y-3 text-sm leading-6 text-slate-700">
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    {isExpanded || !isLongText ? fullText : `${shortText}...`}
                    {isLongText && (
                      <>
                        <span
                          className="fw-bold"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsExpanded(!isExpanded)}
                        >
                          {isExpanded ? lg?.readless : lg?.readmore}
                        </span>
                      </>
                    )}
                  </p>
                </div>

                <h2 className="mt-6 text-lg font-semibold">{lg?.details}</h2>
                <div className="mt-3 space-y-3 text-sm leading-6 text-slate-700">
                  <p style={{ whiteSpace: "pre-wrap" }}>{eventData?.detail} </p>
                </div>
              </Card>
            </div>
          )}
        </Container>
      </div>
      <div className="fixed inset-x-0 bottom-0 z-40 bg-[#d9d9d9] shadow-[0_-4px_16px_rgba(0,0,0,0.15)] ring-1 ring-[#b3b3b3]">
        <div className="mx-auto w-full max-w-7xl px-[24px]">
          <div className="flex flex-col items-center gap-4 py-[20px] sm:flex-row sm:justify-between">
            <div
              className={`flex items-center  gap-8 w-full sm:w-auto ${
                selectedOption === "FULL" ? "justify-between" : ""
              }`}
            >
              <div className="flex gap-2">
                <Pill className="bg-[#ffe4e6] text-[#be123c]">BOOK DUO</Pill>
                <Pill className={getClasses()}>{selectedOption}</Pill>
              </div>
              {selectedOption === "FULL" && (
                <Button
                  className={`block sm:hidden`} // ✅ show on mobile, hide on sm and above
                  variant="secondary"
                  onClick={() => setShowShare(true)}
                >
                  <Share2 size={16} /> {lg?.share || "Share"}
                </Button>
              )}
            </div>
            <div className="flex w-full justify-end gap-3 sm:w-auto">
              {(selectedOption === "OPEN" || selectedOption === "BOOKED") && (
                <Button
                  className="min-w-[102.63px]"
                  variant={
                    selectedOption === "BOOKED" || selectedOption === "FULL"
                      ? "secondary"
                      : "primary"
                  }
                  onClick={
                    selectedOption === "OPEN" ? () => requestChat() : null
                  }
                  disabled={
                    selectedOption === "BOOKED" || selectedOption === "FULL"
                  }
                  aria-pressed={
                    selectedOption === "BOOKED" || selectedOption === "FULL"
                  }
                >
                  {selectedOption === "CONSULTATION"
                    ? "Waiting List"
                    : selectedOption === "BOOKED"
                    ? "Joined"
                    : selectedOption === "OPEN"
                    ? lg?.join
                    : "FULL"}
                </Button>
              )}
              {(selectedOption !== "FULL" || window.innerWidth >= 640) && (
                <Button variant="secondary" onClick={() => setShowShare(true)}>
                  <Share2 size={16} /> {lg?.share || "Share"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={wShow}
        onHide={handleCloseW}
        centered
        className="custom-gropmodelwel"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn2 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold mx-sm-2 text-center mt-1 aboutauther  "
            style={{ fontSize: "27px" }}
          >
            {/* Thank You! */}
            {lg?.thankyou}
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 mt-sm-2">
          <div
            className=" fw600 mx-lg-3 px-lg-5 text-center  w-100 ftzcopy   "
            style={{ fontSize: "18px" }}
          >
            {/* The organizer is now aware of your interest and may send you a
            message to arrange the details of this Book Duo. */}
            {lg?.thankmsg}
          </div>
        </Modal.Body>
      </Modal>
      {showJoined && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setShowJoined(false)}
          />
          <div className="relative z-10 w-full max-w-2xl mx-3 rounded-2xl border-2 border-[#34c3c9] bg-white p-6 shadow-xl">
            <div className="mb-3 flex items-start justify-between">
              <h3 className="text-xl font-semibold text-[#0f172a]">
                {lg?.thankyou}
              </h3>
              <button
                className="text-slate-500"
                onClick={() => {
                  setShowJoined(false);
                  if (user?.isAmbassador) {
                    navigate("/leading"); // Navigate to home page
                  } else {
                    navigate("/leading");
                  }
                }}
                aria-label="Close joined"
              >
                ✕
              </button>
            </div>
            <p className="text-center text-sm sm:text-base text-slate-800 font-medium mb-2">
              {lg?.thankmsg}
            </p>
          </div>
        </div>
      )}
      <Modal
        show={sLShow}
        onHide={handleCloseSL}
        centered
        className="custom-gropshresend"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn closebtnevtn4 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseSL}
          />
        </Modal.Header>
        <Modal.Title className="mx-5  ">
          <div
            className=" fw-bold mx-sm-2 text-center  abcftz  "
            style={{ fontSize: "27px" }}
          >
            Great! You will discuss the details of the 1:1 with{" "}
            <span className="fst-italic" style={{ color: "#34C3C9" }}>
              {" "}
              [NAME OF THE ORGANIZER].
            </span>
          </div>
        </Modal.Title>
        <Modal.Body className="mx-5 mt-md-2 mt-0">
          <div
            className=" fw-normal mx-md-4 mx-2 text-center  w-100 fontmobil   "
            style={{ maxWidth: "592px", fontSize: "17px" }}
          >
            Send a custom message using the box below, once done, the organizer
            will decide if accepting your request.
          </div>
          <div className="mx-2 mt-md-3">
            <div className="fs-5 fw-bold ftlink">Send a message</div>

            <textarea
              type="text"
              className="form-control my-1 w-100  fw-normal fontmobil fs-6 bg-transparent  rounded-1 placeholder-login"
              id="text"
              placeholder="Hi [NAME OF THE ORGANAZIER],
I have an interest in your 1:1, I would like to join and discuss over this book because.…"
              style={{
                border: "2px solid #000000",
                maxWidth: "680px",
                height: "187px",
                color: "#5B5B5B",
              }}
            />
          </div>

          <div className="mt-sm-4 mt-3 text-center ">
            <button
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "162px ",
                fontSize: "22px",
                height: "45px",
                backgroundColor: "#34C3C9",
              }}
            >
              Send
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* Share modal */}
      {showShare && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setShowShare(false)}
          />
          <div className="relative z-10 w-full max-w-lg rounded-2xl border-2 border-[#34c3c9] bg-white p-6 shadow-xl mx-4">
            <div className="mb-3 flex items-start justify-between">
              <h3 className="text-xl font-semibold text-[#0f172a]">
                {lg?.shareThisEvent || "Share this event"}
              </h3>
              <button
                className="text-slate-500"
                onClick={() => setShowShare(false)}
                aria-label="Close share"
              >
                ✕
              </button>
            </div>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {/* WhatsApp */}
              <a
                href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>

              {/* Facebook */}
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Facebook className="h-4 w-4" /> Facebook
              </a>

              {/* Telegram */}
              <a
                href={`https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Send className="h-4 w-4" /> Telegram
              </a>

              {/* Instagram (no API, fallback to link) */}
              <a
                href={shareUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Instagram className="h-4 w-4" /> Instagram
              </a>

              {/* TikTok */}
              <a
                href={`https://www.tiktok.com/share?url=${encodedUrl}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Music className="h-4 w-4" /> TikTok
              </a>

              {/* Twitter/X */}
              <a
                href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Twitter className="h-4 w-4" /> X/Twitter
              </a>

              {/* LinkedIn */}
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Linkedin className="h-4 w-4" /> LinkedIn
              </a>

              {/* Snapchat */}
              <a
                href={`https://www.snapchat.com/scan?attachmentUrl=${encodedUrl}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Camera className="h-4 w-4" /> Snapchat
              </a>

              {/* Copy link */}
              <button
                onClick={() =>
                  navigator.clipboard.writeText(shareUrl).then(() => {
                    toast.success("Link copied to clipboard!");
                  })
                }
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <LinkIcon className="h-4 w-4" /> Copy link
              </button>

              {/* Email */}
              <a
                href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}
                className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
              >
                <Mail className="h-4 w-4" /> Email
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MeetupOrganizer;
